import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { apiFetch } from '../api';
import './Header.css';
// import logo from '../logo.jpeg';

export default function Header({ toggleSidebar }) {
  const { user, setUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const logout = async () => {
    await apiFetch('/api/auth/logout', { method: 'POST' });
    setUser(null);
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-left">
       {/* <img src={logo} alt="Logo" className="header-logo" /> */}
        <button className="icon-btn" onClick={toggleSidebar}>
          ☰
        </button>
        <span className="logo">TejoScan</span>
      </div>
      <div className="header-right">
        <span className="username">{user?.username}</span>
        <button className="logout-btn" onClick={logout}>
          Logout
        </button>
      </div>
    </header>
  );
}
